module.exports = "https://redage.akamaized.net/src/views/games/other/images/maps/mafia1.png";